/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import useWidgetCallbackParams from "../hooks/useWidgetCallbackParams";
import { useGetBooking } from "../lib/react-query/useGetBooking";
import { useBookingApiEntities } from "../hooks/useBookingApiEntities";
import { ROUTES } from "../constants/constants";
import NavigationHeader from "../components/NavigationHeader";
import Container from "../components/Container";
import ClientBookingsItem from "../components/client/ClientBookingsItem";
import LoadingIndicator from "../components/LoadingIndicator";

const CancelBooking = () => {
  const { cancelBookingId, hash, clearParams } = useWidgetCallbackParams();
  const { includeEntities } = useBookingApiEntities("booking");
  const { data: booking, isLoading: isLoadingBooking } = useGetBooking(
    cancelBookingId,
    { hash, include: includeEntities },
  );

  useEffect(() => {
    clearParams();
  }, [clearParams]);

  return (
    <Container>
      <NavigationHeader title="cancel booking" back={ROUTES.HOME} />
      {isLoadingBooking ? (
        <LoadingIndicator page />
      ) : (
        <ClientBookingsItem
          booking={booking}
          isUpcoming={true}
          showCancellationModal={true}
        />
      )}
    </Container>
  );
};

export default CancelBooking;
